import Table from 'components/Table';
import React, { useState } from 'react';
import PersonalAccountCardComponent from './AccountCard/PersonalAccountCardComponent';
import BasicSelect from 'components/BasicInputs/BasicSelect';
import { apiPersonsList } from 'api/personApi';
import { setQueryParam } from 'helpers/queryParam';
import { useDispatch } from 'react-redux';
import { store } from 'store/store';
import { apiGetSalaryByPersons } from 'api/reportApi';

interface SalaryReportByPersonProps {
  // Define any props the component might need here
}
const MiddleComp = () => {
  const [personId, setpersonId] = useState(null)
  const [persons, setPersons] = useState<any>([]);
  const [person, setPerson] = useState<any>({});
const {getState}=store
const token = getState().businessReducer.business?.token;
const pagination = getState().paginationReducer;

const dispatch=useDispatch()

function submit() {
  let { search, sort } = pagination;
        //@ts-ignore
        dispatch(apiGetSalaryByPersons({ pagination, search, sort,  callBack: (res: any) => {} }));
    }
  return (
    <div className="flex gap-4 my-10 flex-wrap">
      <BasicSelect
        key={personId}
        options={persons}
        placeholder={(person && person.label) || "شخص"}
        defaultValue={typeof personId === "string" ? parseInt(personId) : personId}
        onChange={(val) => {
          setQueryParam("personId", val);
          submit()

        }}
        style={{ minWidth: 245 }}
        withSearch
        withRefresh
        // @ts-ignore
        refreshList={() => { if (persons.length === 0) dispatch(apiPersonsList(token, "personnel", (res: any) => setPersons(res))) }}
      />
    </div>

  )


}
const SalaryReportByPerson: React.FC<SalaryReportByPersonProps> = (props) => {
  const [activeTab, setActiveTab] = useState();
  const [options, setOptions] = useState({});
  const [state, setState] = useState({});
  return (
    <Table
      type="SalaryReportByPerson"
      middleComp={
        <MiddleComp />
      }

    />
  );
};

export default SalaryReportByPerson;